<template>
  <div class="product-list">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="分类">
          <el-select size="small" v-model="searchForm.type" placeholder="所有分类" class="filter-select">
            <el-option label="全部" value="ALL"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入名称" class="filter-input"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit" class="search-btn">查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--添加申请-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/supplier/applyment/add'"
                 class="action-btn">添加
      </el-button>
      <el-button size="small" type="info" icon="el-icon-refresh" @click="checkStatus"
                 v-auth="'/supplier/applyment/check'" class="action-btn">一键查询状态
      </el-button>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          size="small"
          :data="tableData"
          border
          style="width: 100%"
          v-loading="loading"
          :header-cell-style="{backgroundColor: '#f5f7fa', color: '#606266'}"
          :cell-style="{padding: '8px 0'}"
          highlight-current-row
        >
          <el-table-column prop="applymentNo" label="申请编号" width="180" show-overflow-tooltip></el-table-column>
          <el-table-column prop="applymentTypeText" label="申请类型" width="100"
                           show-overflow-tooltip></el-table-column>
          <el-table-column prop="supplierName" label="商户名称" width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="申请状态" width="180">
            <template slot-scope="scope">
              <div class="payment-info-cell">
                <el-tooltip effect="light" placement="top" popper-class="status-tooltip">
                  <div slot="content" class="payment-tooltip">
                    <div class="tooltip-item">
                      <span class="label">拉卡拉：</span>
                      <span class="status-text"
                            :class="scope.row.applymentStatus === 41 ? 'success-status' : 'pending-status'">
                        {{ scope.row.applymentStatusText }}
                      </span>
                    </div>
                    <div class="tooltip-item">
                      <span class="label">微信：</span>
                      <span class="status-text"
                            :class="scope.row.wechatApplymentStatus === 41 ? 'success-status' : 'pending-status'">
                        {{ scope.row.wechatApplymentStatusText || '-' }}
                      </span>
                    </div>
                    <div class="tooltip-item">
                      <span class="label">支付宝：</span>
                      <span class="status-text"
                            :class="scope.row.alipayApplymentStatus === 41 ? 'success-status' : 'pending-status'">
                        {{ scope.row.alipayApplymentStatusText || '-' }}
                      </span>
                    </div>
                  </div>

                  <div class="payment-brief">
                    <el-tag size="mini" :type="scope.row.applymentStatus === 41 ? 'success' : 'info'"
                            class="status-tag">
                      拉卡拉: {{ scope.row.applymentStatusText }}
                    </el-tag>
                    <el-tag size="mini" :type="scope.row.wechatApplymentStatus === 41 ? 'success' : 'info'"
                            class="status-tag" style="margin: 2px 0">
                      微信: {{ scope.row.wechatApplymentStatusText || '-' }}
                    </el-tag>
                    <el-tag size="mini" :type="scope.row.alipayApplymentStatus === 41 ? 'success' : 'info'"
                            class="status-tag">
                      支付宝: {{ scope.row.alipayApplymentStatusText || '-' }}
                    </el-tag>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="applymentResult" label="申请状态消息" width="220">
            <template slot-scope="scope">
              <div class="payment-info-cell">
                <el-tooltip effect="light" placement="top" popper-class="status-tooltip">
                  <div slot="content" class="payment-tooltip">
                    <div class="tooltip-item">
                      <span class="label">拉卡拉：</span>
                      <span class="status-text"
                            :class="scope.row.applymentStatus === 41 ? 'success-status' : 'pending-status'">
                        {{ scope.row.applymentResult }}
                      </span>
                    </div>
                    <div class="tooltip-item">
                      <span class="label">微信：</span>
                      <span class="status-text"
                            :class="scope.row.wechatApplymentStatus === 41 ? 'success-status' : 'pending-status'">
                        {{ scope.row.wechatApplymentResult || '-' }}
                      </span>
                    </div>
                    <div class="tooltip-item">
                      <span class="label">支付宝：</span>
                      <span class="status-text"
                            :class="scope.row.alipayApplymentStatus === 41 ? 'success-status' : 'pending-status'">
                        {{ scope.row.alipayApplymentResult || '-' }}
                      </span>
                    </div>
                  </div>

                  <div class="payment-brief">
                    <span>
                      拉卡拉: {{ scope.row.applymentResult }}
                    </span>
                    <span style="margin: 2px 0">
                      微信: {{ scope.row.wechatApplymentResult || '-' }}
                    </span>
                    <span>
                      支付宝: {{ scope.row.alipayApplymentResult || '-' }}
                    </span>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="微信签约链接" width="140" :render-header="renderHeaderMethods">
            <template slot-scope="scope">
              <div class="pic-info">
                <ImagePreview
                  fit="cover"
                  :src="scope.row.wechatSignUrl"></ImagePreview>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="支付宝签约链接" width="140" :render-header="renderHeaderMethods">
            <template slot-scope="scope">
              <div class="pic-info">
                <ImagePreview
                  class="qrcode-image"
                  fit="cover"
                  :src="scope.row.alipaySignUrl"></ImagePreview>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="checkTime" label="审核时间" width="140"></el-table-column>
          <el-table-column prop="createTime" label="申请时间" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width="300">
            <template slot-scope="scope">
              <el-button
                @click="checkStatus(scope.row)"
                type="primary"
                size="mini"
                icon="el-icon-refresh"
                plain
                v-auth="'/supplier/applyment/check'">状态查询
              </el-button>
              <el-button
                v-if="scope.row.applymentStatus === 71"
                @click="reconsiderSubmit(scope.row)"
                type="warning"
                size="mini"
                icon="el-icon-document"
                plain
                v-auth="'/supplier/applyment/check'">进件复议
              </el-button>

              <el-button
                v-else-if="scope.row.applymentStatus === 73"
                @click="replenishSubmit(scope.row)"
                type="info"
                size="mini"
                icon="el-icon-upload2"
                plain
                v-auth="'/supplier/applyment/check'">附件补充
              </el-button>

              <el-button
                @click="editClick(scope.row)"
                type="primary"
                size="mini"
                icon="el-icon-edit"
                plain
                v-auth="'/supplier/applyment/edit'">编辑
              </el-button>
              <el-button
                @click="deleteClick(scope.row)"
                type="danger"
                size="mini"
                icon="el-icon-delete"
                plain
                v-auth="'/supplier/applyment/delete'">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import SupplierApi from '@/api/supplier.js';
import ImagePreview from "@/components/ImagePreview/index.vue";

export default {
  components: {
    ImagePreview,
  },
  data() {
    return {
      /*搜索参数*/
      searchForm: {
        name: '',
        type: 'ALL'
      },
      /*是否加载完成*/
      loading: true,
      content: 'true',
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        user: '',
        region: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  activated() {
    /*解决重回list页面不刷新问题*/
    this.getData();
  },
  methods: {
    renderHeaderMethods(h, {column}) {
      return h(
        'div',
        {
          style: 'display:flex;margin:auto;'
        },
        [
          h('span', column.label),
          h('promptMessages', {
            // 引用 promptMessages 全局组件
            props: {
              // messages 里面配置的信息即为 Tooltip 提示信息
              messages: ['1、超级管理员用微信扫码，关注“微信支付商家助手”公众号后，公众号将自动发送签约消息；超管需点击消息，根据指引完成核对联系信息、账户验证、签约等操作。',
                '2、超管完成核对联系信息，后续申请单进度可通过公众号自动通知超级管理员。']
            }
          })
        ]
      );
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },
    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      SupplierApi.applymentList(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.records;
          self.totalDataNumber = res.data.total;
        })
        .catch(error => {
        });
    },
    checkStatus(item) {
      let self = this;
      //可能会增加勾选操作
      let data = []
      if (item) {
        data.push(item.applymentId)
      }
      let Params = {"ids": data.join(',')};
      SupplierApi.checkApplymentStatus(Params, true)
        .then(res => {
          self.getData();
          self.$message({
            message: res.msg,
            type: 'success'
          });
        })
        .catch(error => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消查询'
          // });
        });
    },
    reconsiderSubmit(item) {
      let self = this;
      SupplierApi.reconsiderSubmit({applymentId: item.applymentId}, true)
        .then(res => {
          self.getData();
          self.$message({
            message: res.msg,
            type: 'success'
          });
        })
        .catch(error => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消进件复议'
          // });
        });
    },
    /*打开添加*/
    addClick() {
      this.$router.push('/supplier/applyment/add');
    },

    /*打开编辑*/
    replenishSubmit(item) {
      let self = this;
      this.$router.push({
        path: '/supplier/applyment/edit',
        query: {
          applymentId: item.applymentId,
          applymentType: item.applymentType,
          op: 'replenish',
        }
      });
    },
    /*打开编辑*/
    editClick(item) {
      let self = this;
      this.$router.push({
        path: '/supplier/applyment/edit',
        query: {
          applymentId: item.applymentId,
          applymentType: item.applymentType,
          op: 'edit',
        }
      });
    },
    viewClick(item) {
      let self = this;
      this.$router.push({
        path: '/supplier/applyment/edit',
        query: {
          applymentId: item.applymentId,
          applymentType: item.applymentType,
          op: 'view',
        }
      });
    },
    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          SupplierApi.deleteApplyment(
            {
              id: row.applymentId
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getData();
            })
            .catch(error => {
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.pic {
  position: relative;
  width: 60px;
  height: 60px;
  background: #F0F0EE;
}

/* 搜索表单样式 */
.filter-select, .filter-input {
  width: 200px;
}

.search-btn {
  margin-left: 10px;
}

.action-btn {
  margin-right: 10px;
}

/* 表格样式 */
.table-wrap {
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
}

/* 状态样式 */
.payment-info-cell {
  padding: 5px 0;
}

.payment-tooltip {
  padding: 5px;
}

.tooltip-item {
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}

.label {
  font-weight: bold;
  margin-right: 5px;
}

.status-text {
  font-size: 13px;
}

.success-status {
  color: #67c23a;
}

.pending-status {
  color: #e6a23c;
}

.payment-brief {
  display: flex;
  flex-direction: column;
}

.status-tag {
  margin: 2px 0;
}

/* 二维码样式 */
.qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
}

.qrcode-image {
  max-width: 120px;
  max-height: 120px;
}

/* 分页样式 */
.pagination {
  text-align: right;
  padding: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/supplier/supplier/applyment/index.vue